var map = {
	"./alignStrategyAnimation.js": "c970",
	"./artificialIntelligenceAnimation.js": "e51a",
	"./baseMixin.js": "c96f",
	"./businessIntelligenceAnimation.js": "2ce1",
	"./commercialAlignmentAnimation.js": "cb52",
	"./customVisualsAnimation.js": "0615",
	"./dataEducationAnimation.js": "a1de",
	"./dataEthicsAnimation.js": "7573",
	"./dataScienceAnimation.js": "569c",
	"./externalDataAnimation.js": "faf9",
	"./handsOnAnimation.js": "5b0b",
	"./index.js": "fb21",
	"./internalDataAnimation.js": "c4b9",
	"./perpetuatingInnovationAnimation.js": "a4d5",
	"./privacyPolicyAnimation.js": "70a7",
	"./securityPolicyAnimation.js": "87fc",
	"./speedIterationAnimation.js": "7f3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b3a";